import './ServiceIllustrations.css';

export const GlueAndPress = () => (
  <svg
    id="glueAndPressIllustration"
    className="serviceIllustration"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 127.57 125.47"
  >
    <defs>
      <clipPath id="clippath">
        <polygon
          className="cls-2"
          points="3 60.42 87.91 109.38 121.84 89.89 37.1 40.7 3 60.42"
        />
      </clipPath>
      <clipPath id="clippath-1">
        <path
          className="cls-2"
          d="m127.57,62.73c-1.43,83.65-125.86,83.64-127.27,0,1.43-83.65,125.86-83.63,127.27,0Z"
        />
      </clipPath>
    </defs>
    <g id="Layer_2-2" data-name="Layer 2">
      <path
        className="cls-5"
        d="m127.57,62.73c-1.43,83.65-125.86,83.64-127.27,0,1.43-83.65,125.86-83.63,127.27,0Z"
      />
      <polygon
        className="cls-3"
        points="0 54.65 84.91 103.61 118.84 84.12 34.1 34.93 0 54.65"
      />
      <polygon
        className="cls-11"
        points="3 60.42 87.91 109.38 121.84 89.89 37.1 40.7 3 60.42"
      />
      <g className="cls-1">
        <polygon
          className="cls-3"
          points="0 54.65 84.91 103.61 118.84 84.12 34.1 34.93 0 54.65"
        />
      </g>
      <polygon
        className="cls-2"
        points="3 60.16 87.91 109.11 121.84 89.62 37.1 40.43 3 60.16"
      />
      <polygon
        className="cls-4"
        points="87.91 109.38 87.91 114.27 121.84 94.78 121.84 89.89 87.91 109.38"
      />
      <polygon
        className="cls-7"
        points="87.91 109.38 3 60.42 3 65.32 87.91 114.27 87.91 109.38"
      />
      <polygon
        className="cls-10"
        points="3 40.72 87.91 89.68 121.84 70.19 37.1 21 3 40.72"
      />
      <polygon
        className="cls-14"
        points="3 35.83 87.91 84.78 121.84 65.3 37.1 16.11 3 35.83"
      />
      <polygon
        className="cls-14"
        points="3 40.72 87.91 89.68 121.84 70.19 37.1 21 3 40.72"
      />
      <polygon
        className="cls-14"
        points="3 45.61 87.91 94.57 121.84 75.08 37.1 25.89 3 45.61"
      />
      <polygon
        className="cls-14"
        points="3 50.51 87.91 99.46 121.84 79.97 37.1 30.78 3 50.51"
      />
      <polygon
        className="cls-13"
        points="87.91 84.78 87.91 89.68 121.84 70.19 121.84 65.3 87.91 84.78"
      />
      <polygon
        className="cls-8"
        points="87.91 89.68 87.91 94.57 121.84 75.08 121.84 70.19 87.91 89.68"
      />
      <polygon
        className="cls-13"
        points="87.91 94.57 87.91 99.46 121.84 79.97 121.84 75.08 87.91 94.57"
      />
      <polygon
        className="cls-12"
        points="87.91 84.78 3 35.83 3 40.72 87.91 89.68 87.91 84.78"
      />
      <polygon
        className="cls-6"
        points="87.91 89.68 3 40.72 3 45.61 87.91 94.57 87.91 89.68"
      />
      <polygon
        className="cls-9"
        points="3 35.83 87.91 84.78 121.84 65.3 37.1 16.11 3 35.83"
      />
      <g className="cls-15">
        <polygon
          className="cls-3"
          points="0 30.06 84.91 79.01 118.84 59.53 34.1 10.34 0 30.06"
        />
      </g>
      <polygon
        className="cls-11"
        points="3 21.06 87.91 70.01 121.84 50.53 37.1 1.34 3 21.06"
      />
      <polygon
        className="cls-4"
        points="87.91 70.01 87.91 74.91 121.84 55.42 121.84 50.53 87.91 70.01"
      />
      <polygon
        className="cls-7"
        points="87.91 70.01 3 21.06 3 25.95 87.91 74.91 87.91 70.01"
      />
      <polygon
        className="cls-12"
        points="87.91 94.57 3 45.61 3 50.51 87.91 99.46 87.91 94.57"
      />
    </g>
  </svg>
);

export const Sawing = () => (
  <svg
    id="sawingIllustration"
    className="serviceIllustration"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 141.62 139.85"
  >
    <g id="Layer_1-2">
      <g>
        <circle className="cls-3" cx="63.64" cy="76.21" r="63.64" />
        <polygon
          className="cls-8"
          points="12.7 49.31 97.61 98.26 131.54 78.78 46.81 29.59 12.7 49.31"
        />
        <polygon
          className="cls-1"
          points="97.61 98.26 97.61 103.16 131.54 83.67 131.54 78.78 97.61 98.26"
        />
        <polygon
          className="cls-11"
          points="97.61 103.16 97.61 108.05 131.54 88.56 131.54 83.67 97.61 103.16"
        />
        <polygon
          className="cls-7"
          points="97.61 108.05 97.61 112.94 131.54 93.45 131.54 88.56 97.61 108.05"
        />
        <polygon
          className="cls-11"
          points="97.61 112.94 97.61 117.83 131.54 98.34 131.54 93.45 97.61 112.94"
        />
        <polygon
          className="cls-1"
          points="97.61 117.83 97.61 122.72 131.54 103.24 131.54 98.34 97.61 117.83"
        />
        <polygon
          className="cls-6"
          points="97.61 98.26 12.7 49.31 12.7 54.2 97.61 103.16 97.61 98.26"
        />
        <polygon
          className="cls-10"
          points="97.61 103.16 12.7 54.2 12.7 59.09 97.61 108.05 97.61 103.16"
        />
        <polygon
          className="cls-5"
          points="97.61 108.05 12.7 59.09 12.7 63.99 97.61 112.94 97.61 108.05"
        />
        <polygon
          className="cls-10"
          points="97.61 112.94 12.7 63.99 12.7 68.88 97.61 117.83 97.61 112.94"
        />
        <polygon
          className="cls-6"
          points="97.61 117.83 12.7 68.88 12.7 73.77 97.61 122.72 97.61 117.83"
        />
        <polygon
          className="cls-1"
          points="85.16 53.63 62.52 66.99 57.9 64.68 80.88 51.33 85.16 53.63"
        />
        <path
          className="cls-2"
          d="m107.24,64.85c-6.49-3.75-13-7.48-19.46-11.28-.99-.58-1.7-.48-2.62.07-2.34,1.4-4.74,2.7-7.12,4.04.16-.28.35-.55.48-.85.32-.72.78-1.43.89-2.18.18-1.29-.57-1.73-1.72-1.12-.65.35-1.29.72-2.11,1.17.08-.43.08-.64.16-.81.73-1.68,1.48-3.36,2.2-5.05.52-1.23,1.29-2.2,2.36-3.04.82-.65,1.58-1.48,2.09-2.39.3-.54.29-1.49,0-2.04-.16-.31-1.17-.21-1.8-.21-.32,0-.65.17-.98.26-.07-.08-.14-.17-.21-.25,1.27-1.87,2.43-3.83,3.84-5.58.81-1,1.93-1.85,3.07-2.45,1.65-.87,2.23-1.57,2.2-3.39-.01-.78-.39-1.09-1.09-1.15-.47-.04-.94-.05-1.52-.08.88-.98,1.63-1.83,2.4-2.65.78-.83,1.51-1.74,2.42-2.39.8-.58,1.8-1.15,2.75-1.22,1.49-.11,2.32-.45,2.88-2.07.38-1.1.31-2.26-1-2.9-.16-.08-.28-.24-.62-.54,2-1.24,3.87-2.43,5.77-3.57.59-.35,1.17-.22,1.78.17,1.08.69,2.02.43,2.77-.6.87-1.2,1.26-2.41.33-3.78-.28-.41-.53-.98.2-1.23,1.35-.48,2.7-.95,4.08-1.34.8-.23,1.5.09,2.02.77.22.29.45.57.67.87.4.53.84.52,1.4.22,1.34-.74,2.06-2.46,1.75-4.26-.07-.4-.06-.82-.09-1.16h3.62c.24.08.48.15.73.23.91.61,1.45,1.39,1.48,2.55.01.42.34,1,.69,1.19.28.15.89-.11,1.23-.36.92-.67,1.44-1.63,1.64-2.75.13-.75.27-1.49.4-2.24,1.07.69,2.15,1.39,3.22,2.08.73,1.44.9,2.92.48,4.5-.19.72.38,1.25,1.12,1.08.43-.1.98-.32,1.16-.66.75-1.34,1.38-2.75,2.05-4.14.74,1.54,1.47,3.08,2.21,4.62-.08.82-.1,1.66-.27,2.46-.13.64-.56,1.23-.63,1.87-.06.56,0,1.33.35,1.68.22.23,1.28.07,1.55-.25.9-1.11,1.62-2.38,2.4-3.58.16,1.95.4,3.89.46,5.84.03.87-.3,1.74-.46,2.61-.56,1-1.21,1.97-1.65,3.02-.15.35.11,1,.38,1.38.37.52.94.4,1.41.04.31-.24.58-.53.86-.8.61-.6,1.21-1.21,1.81-1.82-.4,2.16-.77,4.32-1.21,6.47-.34,1.65-1.43,2.9-2.47,4.16-.31.78-.77,1.54-.89,2.35-.17,1.16.39,1.47,1.42.92.82-.43,1.64-.87,2.46-1.3-.97,2.3-1.82,4.65-2.97,6.86-.57,1.1-1.69,1.92-2.56,2.87-.46.5-.91,1.02-1.37,1.53-.11.23-.33.47-.32.69.03.53,0,1.22.3,1.53.29.29,1,.26,1.5.2.47-.06.91-.35,1.36-.54-.05.26-.03.56-.16.76-1.11,1.75-2.26,3.49-3.38,5.23-.16.25-.27.52-.4.78-1.3.76-2.71,1.37-3.85,2.32-.66.54-.87,1.62-1.28,2.45.02,1.15.24,1.38,1.34,1.41.29,0,.58,0,.88,0,0,0-.01,0-.01,0,.12.06.24.13.36.19-1.76,1.84-3.43,3.77-5.33,5.46-.67.59-1.89.55-2.84.84-.43.13-.9.29-1.2.59-.39.39-.69.9-.92,1.41-.58,1.28-.43,1.78.67,2.65.21.16.41.33.65.52-.05.14-.06.31-.14.36-.2.13-.39.26-.59.39l-13.42-7.61Zm2.9-28.45c-.71.27-1.48.43-2.11.82-2.78,1.73-4.48,4.32-5.53,7.36-.57,1.65-.88,3.34-.39,5.08.26.56.42,1.21.81,1.67,1.22,1.44,3.38,1.57,5.28.34,3.41-2.21,5.25-5.47,6.17-9.34.36-1.53.2-2.98-.53-4.36-.71-1.36-2.36-2.03-3.69-1.57Z"
        />
        <path
          className="cls-9"
          d="m119.01,2.82h-3.62c.02.34.02.76.09,1.16.31,1.79-.41,3.51-1.75,4.26-.55.31-1,.31-1.4-.22-.22-.29-.45-.58-.67-.87-.51-.68-1.22-1-2.02-.77-1.38.39-2.73.86-4.08,1.34-.72.26-.47.83-.2,1.23.93,1.37.54,2.58-.33,3.78-.75,1.03-1.69,1.29-2.77.6-.61-.39-1.19-.52-1.78-.17-1.9,1.14-3.78,2.33-5.77,3.57.34.3.46.46.62.54,1.31.64,1.38,1.8,1,2.9-.56,1.61-1.38,1.96-2.88,2.07-.95.07-1.95.63-2.75,1.22-.91.66-1.64,1.57-2.42,2.39-.78.82-1.52,1.68-2.4,2.65.58.03,1.05.04,1.52.08.7.06,1.07.37,1.09,1.15.03,1.82-.55,2.52-2.2,3.39-1.14.6-2.26,1.45-3.07,2.45-1.41,1.76-2.57,3.71-3.84,5.58.07.08.14.17.21.25.33-.09.65-.26.98-.26.63,0,1.64-.09,1.8.21.29.55.3,1.5,0,2.04-.51.91-1.26,1.74-2.09,2.39-1.06.84-1.84,1.81-2.36,3.04-.71,1.69-1.47,3.36-2.2,5.05-.07.17-.08.37-.16.81.81-.45,1.45-.82,2.11-1.17,1.15-.61,1.9-.17,1.72,1.12-.11.75-.57,1.46-.89,2.18-.13.29-.32.57-.48.85,0,0,0-.01,0-.01-.07.07-.14.14-.21.21-1.64.95-3.27,1.91-4.92,2.84-.63.35-1.3.63-1.96.94.45-1.81.41-3.76,1.61-5.35.55-.77,1.1-1.54,1.69-2.36-.82-.5-1.53-.99-2.29-1.4-.7-.38-.82-.76-.47-1.52.83-1.77,1.54-3.6,2.3-5.41,1.14-1.23,2.28-2.46,3.42-3.7.29-.31.55-.65.84-1-1.05-.64-2.03-1.23-3.17-1.93,1.06-1.71,2.06-3.44,3.18-5.08,1.14-1.66,2.55-3.01,4.51-3.75.98-.37,1.48-1.28,1.67-2.44-.9-.57-1.83-1.16-2.86-1.81,1.78-1.84,3.43-3.69,5.25-5.35.63-.57,1.66-.83,2.54-.95,1.61-.22,2.45-.71,2.85-2.01.38-1.25.02-2.15-1.26-3.13-.05-.03-.06-.11-.18-.39.49-.37,1-.79,1.55-1.16.93-.61,1.9-1.17,2.84-1.78,1.08-.69,2.1-1.17,3.37-.27.34.24,1.17.08,1.63-.16,1.16-.61,2.18-2.68,1.15-4.11-.39-.55-.46-1.13-.03-1.7,1.09-.28,2.21-.48,3.25-.88,1.25-.48,2.33-.4,3.36.46.1.08.22.15.33.22,1.74,1.12,2.98.46,3.09-1.67.05-.99,0-1.99,0-3.02,3.06-.11,5.68.73,7.86,2.81Z"
        />
        <path
          className="cls-4"
          d="m110.13,36.4c1.33-.46,2.98.21,3.69,1.57.72,1.38.89,2.83.53,4.36-.92,3.87-2.76,7.13-6.17,9.34-1.89,1.23-4.05,1.09-5.28-.34-.39-.46-.55-1.1-.81-1.67.53-.16,1.1-.24,1.59-.49,1.62-.84,2.85-2.14,3.89-3.62,1.93-2.75,2.96-5.74,2.56-9.14Z"
        />
      </g>
    </g>
  </svg>
);

export const Edgebanding = () => (
  <svg
    id="edgebandingIllustration"
    className="serviceIllustration"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 131.54 127.27"
  >
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <circle className="cls-2" cx="63.64" cy="63.64" r="63.64" />
        <polygon
          className="cls-6"
          points="12.7 41.63 97.61 90.58 131.54 71.09 46.81 21.91 12.7 41.63"
        />
        <polygon
          className="cls-7"
          points="12.7 36.74 97.61 85.69 131.54 66.2 46.81 17.01 12.7 36.74"
        />
        <polygon
          className="cls-1"
          points="97.61 85.69 97.61 90.58 131.54 71.09 131.54 66.2 97.61 85.69"
        />
        <polygon
          className="cls-9"
          points="97.61 90.58 97.61 95.47 131.54 75.99 131.54 71.09 97.61 90.58"
        />
        <polygon
          className="cls-5"
          points="97.61 95.47 97.61 100.36 131.54 80.88 131.54 75.99 97.61 95.47"
        />
        <polygon
          className="cls-9"
          points="97.61 100.36 97.61 105.25 131.54 85.77 131.54 80.88 97.61 100.36"
        />
        <polygon
          className="cls-1"
          points="97.61 105.25 97.61 110.15 131.54 90.66 131.54 85.77 97.61 105.25"
        />
        <polygon
          className="cls-4"
          points="97.61 85.69 12.7 36.74 12.7 41.63 97.61 90.58 97.61 85.69"
        />
        <polygon
          className="cls-8"
          points="97.61 90.58 12.7 41.63 12.7 46.52 97.61 95.47 97.61 90.58"
        />
        <polygon
          className="cls-3"
          points="97.61 95.47 12.7 46.52 12.7 51.41 97.61 100.36 97.61 95.47"
        />
        <polygon
          className="cls-8"
          points="97.61 100.36 12.7 51.41 12.7 56.3 97.61 105.25 97.61 100.36"
        />
        <polygon
          className="cls-4"
          points="97.61 105.25 12.7 56.3 12.7 61.19 97.61 110.15 97.61 105.25"
        />
        <path
          className="cls-7"
          d="m12.7,36.69l44.89,25.88c4.05,2.34,5.68,5,5.62,7.75-.11,5.29-8.42,6.94-15.69,11.32v24.56c7.34-4.42,15.71-6.14,15.69-11.48,0-2.7-1.65-5.3-5.62-7.59L12.7,61.24v-24.56"
        />
        <path
          className="cls-1"
          d="m63.21,70.32c-.11,5.29-8.42,6.94-15.69,11.32v24.56c7.34-4.42,15.71-6.14,15.69-11.48v-24.4Z"
        />
      </g>
    </g>
  </svg>
);

export const EdgeProfiling = () => (
  <svg
    viewBox="0 0 64 64"
    className="serviceIllustration"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2387_908)">
      <path
        d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
        fill="#4D4D4D"
      />
      <path
        className="i-tertiary"
        d="M8.82324 23.2628L50.0141 47.9988L62.9999 40.2899L21.775 15.5538L8.82324 23.2628Z"
      />
      <path d="M5.1792 30.3934L46.4917 55.0088L63.0001 45.2129L21.7752 20.4769L5.1792 30.3934Z" />
      <path d="M5.1792 32.8524L46.4917 57.4678L63.0001 47.672L21.7752 22.9359L5.1792 32.8524Z" />
      <path d="M5.1792 35.3115L46.4917 59.9269L63.0001 50.131L21.7752 25.3949L5.1792 35.3115Z" />
      <path d="M5.1792 37.7705L46.4917 62.3909L63.0001 52.59L21.7752 27.8539L5.1792 37.7705Z" />
      <path
        className="dark-grey"
        d="M46.4917 50.0908V52.5498L63.0001 42.7489V40.2899L46.4917 50.0908Z"
      />
      <path
        className="light-grey"
        d="M46.4917 52.5498V55.0088L63.0001 45.2129V42.7489L46.4917 52.5498Z"
      />
      <path
        className="dark-grey"
        d="M46.4917 55.0088V57.4678L63.0001 47.672V45.2129L46.4917 55.0088Z"
      />
      <path
        className="light-grey"
        d="M46.4917 57.4678V59.9268L63.0001 50.131V47.6719L46.4917 57.4678Z"
      />
      <path
        className="dark-grey"
        d="M46.4917 59.9269V62.3909L63.0001 52.59V50.131L46.4917 59.9269Z"
      />
      <path
        className="i-primary"
        d="M50.0143 47.9988L8.82346 23.2628L7.10596 26.6269L48.253 51.5038L50.0143 47.9988Z"
      />
      <path
        className="i-secondary"
        d="M48.2529 51.5038L7.10591 26.6269L5.1792 30.3934L46.4917 55.0088L48.2529 51.5038Z"
      />
      <path
        className="i-primary"
        d="M46.4917 55.0088L5.1792 30.3934V32.8524L46.4917 57.4678V55.0088Z"
      />
      <path
        className="i-secondary"
        d="M46.4917 57.4678L5.1792 32.8524V35.3115L46.4917 59.9269V57.4678Z"
      />
      <path
        className="i-primary"
        d="M46.4917 59.9268L5.1792 35.3115V37.7705L46.4917 62.3909V59.9268Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_2387_908">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Labeling = () => (
  <svg
    viewBox="0 0 64 64"
    className="serviceIllustration"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
      fill="#4D4D4D"
    />
    <path
      d="M5.1792 26.9344L46.4917 51.5498L63.0001 41.7489L21.7752 17.0178L5.1792 26.9344Z"
      className="i-secondary"
    />
    <path
      d="M5.1792 24.4754L46.4917 49.0908L63.0001 39.2899L21.7752 14.5538L5.1792 24.4754Z"
      className="i-tertiary"
    />
    <path
      d="M5.1792 26.9344L46.4917 51.5498L63.0001 41.7489L21.7752 17.0178L5.1792 26.9344Z"
      className="i-tertiary"
    />
    <path
      d="M5.1792 29.3934L46.4917 54.0088L63.0001 44.2129L21.7752 19.4769L5.1792 29.3934Z"
      className="i-tertiary"
    />
    <path
      d="M5.1792 31.8524L46.4917 56.4678L63.0001 46.672L21.7752 21.9359L5.1792 31.8524Z"
      className="i-tertiary"
    />
    <path
      d="M5.1792 34.3115L46.4917 58.9269L63.0001 49.131L21.7752 24.3949L5.1792 34.3115Z"
      className="i-tertiary"
    />
    <path
      d="M5.1792 36.7705L46.4917 61.3909L63.0001 51.59L21.7752 26.8539L5.1792 36.7705Z"
      className="i-tertiary"
    />
    <path
      d="M46.4917 49.0908V51.5498L63.0001 41.7489V39.2899L46.4917 49.0908Z"
      className="i-secondary"
    />
    <path
      d="M46.4917 51.5498V54.0088L63.0001 44.2129V41.7489L46.4917 51.5498Z"
      className="i-tertiary"
    />
    <path
      d="M46.4917 54.0088V56.4678L63.0001 46.672V44.2129L46.4917 54.0088Z"
      className="i-secondary"
    />
    <path
      d="M46.4917 56.4678V58.9268L63.0001 49.131V46.672L46.4917 56.4678Z"
      className="i-tertiary"
    />
    <path
      d="M46.4917 58.9269V61.3909L63.0001 51.59V49.131L46.4917 58.9269Z"
      className="i-secondary"
    />
    <path
      d="M46.4917 49.0908L5.1792 24.4754V26.9344L46.4917 51.5498V49.0908Z"
      className="i-primary"
    />
    <path
      d="M46.4917 51.5498L5.1792 26.9344V29.3934L46.4917 54.0088V51.5498Z"
      className="i-secondary"
    />
    <path
      d="M46.4917 54.0088L5.1792 29.3934V31.8524L46.4917 56.4678V54.0088Z"
      className="i-primary"
    />
    <path
      d="M46.4917 56.4678L5.1792 31.8524V34.3115L46.4917 58.9269V56.4678Z"
      className="i-secondary"
    />
    <path
      d="M46.4917 58.9268L5.1792 34.3115V36.7705L46.4917 61.3909V58.9268Z"
      className="i-primary"
    />
    <path
      d="M20.1987 28.2921L40.0497 40.1196L47.9853 35.4127L28.1732 23.5249L20.1987 28.2921Z"
      fill="white"
    />
    <path
      d="M26.981 26.2807L38.3028 33.0141L39.1494 32.5112L27.8324 25.7728L26.981 26.2807Z"
      fill="#4D4D4D"
    />
    <path
      d="M24.8403 27.3618L36.1622 34.0952L37.0088 33.5924L25.6918 26.8539L24.8403 27.3618Z"
      fill="#4D4D4D"
    />
  </svg>
);

export const DirectQuote = () => (
  <svg
    id="directQuoteIllustration"
    className="serviceIllustration"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 127.27 127.27"
  >
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <circle className="cls-1" cx="63.64" cy="63.64" r="63.64" />
        <g>
          <path
            className="cls-3"
            d="m21.71,81.65c-4.09-2.38-8.18-4.77-12.27-7.15-1.81-1.05-3.63-2.1-5.63-3.25,4.49-2.61,8.85-5.14,13.21-7.66.2-.11.41-.22.61-.34,20.75-11.98,41.51-23.95,62.25-35.95.59-.34,1.01-.38,1.63-.02,3.39,2,6.81,3.96,10.22,5.92,4.69,2.69,9.38,5.38,14.06,8.07,4.32,2.51,8.64,5.01,12.95,7.53,1.66.97,3.29,1.98,4.94,2.98-2.87,1.62-5.74,3.24-8.6,4.87-.97.55-1.92,1.13-3.01,1.78,3.99,2.34,7.8,4.57,11.62,6.81-4.11,2.4-8.23,4.8-12.34,7.2-.98.57-1.95,1.15-2.93,1.73-.32.17-.65.34-.97.52-15.95,9.21-31.9,18.41-47.84,27.64-.72.42-1.25.45-1.99.02-8.13-4.73-16.28-9.44-24.44-14.14-3.81-2.2-7.64-4.37-11.47-6.56Zm26.99-27.21c.23.1.32.14.4.19,13.39,7.73,26.77,15.46,40.16,23.18.2.12.54.22.72.13.73-.36,1.42-.79,2.23-1.26-.35-.21-.55-.32-.74-.44-4.97-2.87-9.94-5.75-14.91-8.62-8.27-4.78-16.53-9.55-24.81-14.31-.24-.14-.66-.2-.9-.09-.68.31-1.32.74-2.15,1.22Zm30.01,29.94c-.25-.16-.41-.26-.58-.36-5.35-3.08-10.7-6.16-16.04-9.25-7.89-4.56-15.76-9.13-23.66-13.67-.28-.16-.74-.25-1.01-.13-.69.3-1.32.74-2.03,1.15.17.14.26.24.37.31,4.42,2.55,8.84,5.1,13.27,7.65,8.47,4.89,16.96,9.72,25.37,14.71,1.54.91,2.7.98,4-.11.07-.06.14-.13.31-.28Zm-47.79-19.68c.29.2.47.34.66.45,6.76,3.91,13.51,7.82,20.27,11.72,6.44,3.72,12.88,7.44,19.34,11.14.3.17.8.28,1.09.16.69-.28,1.31-.73,2.04-1.16-.28-.18-.45-.29-.61-.39-5.86-3.39-11.73-6.77-17.59-10.16-7.37-4.26-14.73-8.52-22.1-12.76-.3-.17-.79-.23-1.1-.11-.67.27-1.27.69-2,1.1Zm56.77,14.57c-.38-.25-.57-.38-.77-.5-3.09-1.78-6.19-3.56-9.28-5.35-10.11-5.84-20.22-11.69-30.33-17.52-.24-.14-.61-.27-.81-.18-.72.35-1.4.8-2.2,1.27.36.22.52.32.7.42,4.48,2.58,8.96,5.16,13.44,7.75,8.78,5.07,17.56,10.15,26.35,15.21.23.13.6.23.8.13.68-.33,1.31-.76,2.1-1.24Zm-4.46,2.6c-.34-.22-.52-.36-.72-.48-4.1-2.37-8.21-4.74-12.31-7.11-8.87-5.12-17.74-10.25-26.62-15.37-1.4-.81-2.43-.58-3.54.77.2.12.39.25.59.36,3.99,2.3,7.98,4.61,11.97,6.91,9.19,5.31,18.38,10.62,27.59,15.9.32.18.84.21,1.18.08.61-.23,1.15-.64,1.87-1.06Zm-56.8-14.58c.35.23.54.36.74.48,4.86,2.8,9.71,5.6,14.57,8.41,8.35,4.83,16.7,9.66,25.05,14.47.25.15.67.25.91.15.69-.3,1.33-.73,2.14-1.19-.44-.27-.71-.44-.98-.6-4.91-2.84-9.82-5.68-14.74-8.51-8.21-4.74-16.42-9.48-24.64-14.2-.3-.17-.79-.24-1.1-.11-.64.26-1.21.67-1.95,1.11Zm53.69-15.44c-.26-.16-.51-.33-.77-.48-3.87-2.24-7.74-4.47-11.61-6.71-1.23-.71-1.58-.65-2.58.44.91.54,1.82,1.07,2.78,1.64-.21.25-.35.42-.5.6-2.07,2.55-1.95,5.44.57,7.52,1.34,1.1,2.94,1.97,4.55,2.61,2.58,1.03,5.33,1.34,8.19,1.13-.07-.77-.13-1.46-.18-2.06-1.53-.19-2.96-.3-4.37-.56-1.82-.34-3.56-.95-4.92-2.29-1.57-1.54-1.62-3.43-.14-5.11,2.01,1.16,4.07,2.25,6.02,3.51,1.09.7,1.96.82,2.94-.24Zm3.08-1.78c-2.4-1.39-4.76-2.76-7.11-4.12,0-.11.02-.22.02-.32,1.53-.11,3.07-.32,4.6-.31,2.38.02,4.62.61,6.58,2.06,1.33.99,2.03,2.33,2.15,3.96h3.88c0-.24,0-.41,0-.57-.01-.17-.04-.33-.07-.49-.43-2.33-1.94-3.84-3.88-4.96-4.68-2.68-9.7-2.93-14.84-1.76-1.31.3-2.45.43-3.5-.52-1.05-.95-1.97-.61-2.9.27,4.07,2.36,8.16,4.66,12.18,7.08,1.1.66,1.92.68,2.88-.31Z"
          />
          <path
            className="cls-2"
            d="m123.68,65.24c-3.82-2.24-7.63-4.47-11.62-6.81,1.09-.64,2.04-1.22,3.01-1.78,2.86-1.63,5.74-3.25,8.6-4.87.05.22.15.43.15.65.02,4.06.02,8.12.02,12.18,0,.21-.11.42-.16.63Z"
          />
          <path
            className="cls-1"
            d="m48.71,54.44c.84-.49,1.47-.91,2.15-1.22.24-.11.65-.05.9.09,8.28,4.76,16.54,9.54,24.81,14.31,4.97,2.87,9.94,5.75,14.91,8.62.2.11.39.23.74.44-.81.47-1.5.9-2.23,1.26-.18.09-.52-.01-.72-.13-13.39-7.72-26.78-15.45-40.16-23.18-.08-.05-.18-.08-.4-.19Z"
          />
          <path
            className="cls-1"
            d="m78.72,84.38c-.16.15-.23.22-.31.28-1.31,1.09-2.46,1.02-4,.11-8.41-4.99-16.9-9.82-25.37-14.71-4.42-2.55-8.85-5.1-13.27-7.65-.11-.06-.2-.17-.37-.31.71-.41,1.34-.85,2.03-1.15.27-.12.73-.03,1.01.13,7.89,4.54,15.77,9.11,23.66,13.67,5.34,3.09,10.69,6.17,16.04,9.25.17.1.33.21.58.36Z"
          />
          <path
            className="cls-1"
            d="m30.92,64.69c.72-.41,1.33-.83,2-1.1.31-.12.8-.06,1.1.11,7.38,4.24,14.74,8.5,22.1,12.76,5.86,3.39,11.73,6.77,17.59,10.16.17.1.33.21.61.39-.74.43-1.36.88-2.04,1.16-.3.12-.79.02-1.09-.16-6.45-3.7-12.9-7.42-19.34-11.14-6.76-3.91-13.52-7.81-20.27-11.72-.19-.11-.37-.25-.66-.45Z"
          />
          <path
            className="cls-1"
            d="m87.7,79.27c-.8.48-1.43.91-2.1,1.24-.2.1-.58,0-.8-.13-8.79-5.06-17.57-10.14-26.35-15.21-4.48-2.59-8.96-5.17-13.44-7.75-.17-.1-.34-.2-.7-.42.8-.47,1.48-.92,2.2-1.27.2-.1.58.04.81.18,10.11,5.83,20.22,11.68,30.33,17.52,3.09,1.79,6.19,3.56,9.28,5.35.2.11.39.25.77.5Z"
          />
          <path
            className="cls-1"
            d="m83.24,81.86c-.72.42-1.26.83-1.87,1.06-.34.13-.87.1-1.18-.08-9.21-5.28-18.39-10.59-27.59-15.9-3.99-2.3-7.98-4.6-11.97-6.91-.2-.11-.39-.24-.59-.36,1.11-1.34,2.14-1.58,3.54-.77,8.88,5.12,17.75,10.24,26.62,15.37,4.1,2.37,8.21,4.74,12.31,7.11.2.11.38.25.72.48Z"
          />
          <path
            className="cls-1"
            d="m26.44,67.29c.75-.44,1.32-.86,1.95-1.11.31-.12.8-.06,1.1.11,8.22,4.72,16.43,9.46,24.64,14.2,4.91,2.84,9.83,5.68,14.74,8.51.28.16.55.33.98.6-.81.47-1.45.89-2.14,1.19-.24.11-.65,0-.91-.15-8.36-4.81-16.7-9.65-25.05-14.47-4.85-2.81-9.71-5.6-14.57-8.41-.2-.11-.39-.25-.74-.48Z"
          />
          <path
            className="cls-1"
            d="m80.14,51.85c-.98,1.06-1.85.94-2.94.24-1.96-1.26-4.02-2.35-6.02-3.51-1.48,1.68-1.43,3.56.14,5.11,1.36,1.34,3.1,1.95,4.92,2.29,1.4.27,2.84.37,4.37.56.05.6.11,1.28.18,2.06-2.85.21-5.6-.1-8.19-1.13-1.61-.64-3.22-1.51-4.55-2.61-2.53-2.08-2.64-4.97-.57-7.52.14-.18.29-.35.5-.6-.96-.57-1.87-1.1-2.78-1.64.99-1.09,1.35-1.15,2.58-.44,3.87,2.24,7.74,4.47,11.61,6.71.26.15.51.31.77.48Z"
          />
          <path
            className="cls-1"
            d="m83.21,50.07c-.96.99-1.79.97-2.88.31-4.02-2.42-8.11-4.73-12.18-7.08.92-.87,1.85-1.22,2.9-.27,1.05.95,2.19.82,3.5.52,5.13-1.17,10.15-.92,14.84,1.76,1.94,1.11,3.46,2.62,3.88,4.96.03.16.06.33.07.49.01.17,0,.33,0,.57h-3.88c-.12-1.63-.81-2.97-2.15-3.96-1.96-1.45-4.2-2.03-6.58-2.06-1.53-.01-3.07.2-4.6.31,0,.11-.02.22-.02.32,2.36,1.37,4.71,2.73,7.11,4.12Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const Optimisation = () => {
  return (
    <svg
      id="optimisationIllustration"
      className="serviceIllustration"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 132.72 127.27"
    >
      <g id="Layer_2-2" data-name="Layer 2">
        <g>
          <circle className="cls-2" cx="65.45" cy="63.64" r="63.64" />
          <polygon
            className="cls-4"
            points="109.84 78.65 39.5 38.25 62.36 25.81 132.7 66.22 109.84 78.65"
          />
          <polygon
            className="cls-3"
            points="109.88 78.67 39.66 38.38 39.66 42.43 109.88 82.72 109.88 78.67"
          />
          <polygon
            className="cls-3"
            points="85.38 91.77 15.15 51.48 15.15 55.54 85.38 95.83 85.38 91.77"
          />
          <polygon
            className="cls-1"
            points="109.86 78.62 109.86 82.67 132.72 70.29 132.72 66.23 109.86 78.62"
          />
          <polygon
            className="cls-1"
            points="85.38 91.85 85.38 95.91 108.34 83.47 108.34 79.42 85.38 91.85"
          />
          <polygon
            className="cls-1"
            points="59.67 94.04 59.67 98.1 72.83 90.88 72.83 86.82 59.67 94.04"
          />
          <polygon
            className="cls-3"
            points="59.68 94.02 0 59.61 0 63.67 59.68 98.08 59.68 94.02"
          />
          <polygon
            className="cls-4"
            points="59.67 94.02 0 59.61 13.14 52.46 72.81 86.87 59.67 94.02"
          />
          <polygon
            className="cls-4"
            points="85.45 91.86 15.11 51.45 37.97 39.01 108.31 79.42 85.45 91.86"
          />
        </g>
      </g>
    </svg>
  );
};

export const MaterialSandwitch = () => {
  return (
    <svg
      id="materialSandwitchIllustration"
      className="serviceIllustration"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.57 125.47"
    >
      <defs>
        <clipPath id="clippath">
          <path
            className="cls-2"
            d="m127.57,62.73c-1.43,83.65-125.86,83.64-127.27,0,1.43-83.65,125.86-83.63,127.27,0Z"
          />
        </clipPath>
      </defs>
      <g id="Layer_2-2" data-name="Layer 2">
        <path
          className="cls-4"
          d="m127.57,62.73c-1.43,83.65-125.86,83.64-127.27,0,1.43-83.65,125.86-83.63,127.27,0Z"
        />
        <polygon
          className="cls-8"
          points="3 58.72 87.91 107.68 121.84 88.19 37.1 39 3 58.72"
        />
        <polygon
          className="cls-11"
          points="3 53.83 87.91 102.78 121.84 83.3 37.1 34.11 3 53.83"
        />
        <polygon
          className="cls-11"
          points="3 58.72 87.91 107.68 121.84 88.19 37.1 39 3 58.72"
        />
        <polygon
          className="cls-11"
          points="3 63.61 87.91 112.57 121.84 93.08 37.1 43.89 3 63.61"
        />
        <polygon
          className="cls-11"
          points="3 68.51 87.91 117.46 121.84 97.97 37.1 48.78 3 68.51"
        />
        <polygon
          className="cls-10"
          points="87.91 102.78 87.91 107.68 121.84 88.19 121.84 83.3 87.91 102.78"
        />
        <polygon
          className="cls-6"
          points="87.91 107.68 87.91 112.57 121.84 93.08 121.84 88.19 87.91 107.68"
        />
        <polygon
          className="cls-10"
          points="87.91 112.57 87.91 117.46 121.84 97.97 121.84 93.08 87.91 112.57"
        />
        <polygon
          className="cls-9"
          points="87.91 102.78 3 53.83 3 58.72 87.91 107.68 87.91 102.78"
        />
        <polygon
          className="cls-5"
          points="87.91 107.68 3 58.72 3 63.61 87.91 112.57 87.91 107.68"
        />
        <polygon
          className="cls-7"
          points="3 53.83 87.91 102.78 121.84 83.3 37.1 34.11 3 53.83"
        />
        <g className="cls-1">
          <polygon
            className="cls-3"
            points="0 49.06 84.91 98.01 118.84 78.53 34.1 29.34 0 49.06"
          />
        </g>
        <polygon
          className="cls-9"
          points="87.91 112.57 3 63.61 3 68.51 87.91 117.46 87.91 112.57"
        />
        <polygon
          className="cls-10"
          points="87.91 78.37 87.91 83.26 121.84 63.77 121.84 58.88 87.91 78.37"
        />
        <polygon
          className="cls-6"
          points="87.91 83.26 87.91 88.15 121.84 68.66 121.84 63.77 87.91 83.26"
        />
        <polygon
          className="cls-10"
          points="87.91 88.15 87.91 93.04 121.84 73.56 121.84 68.66 87.91 88.15"
        />
        <polygon
          className="cls-9"
          points="87.91 78.37 3 29.41 3 34.3 87.91 83.26 87.91 78.37"
        />
        <polygon
          className="cls-5"
          points="87.91 83.26 3 34.3 3 39.2 87.91 88.15 87.91 83.26"
        />
        <polygon
          className="cls-7"
          points="3 29.41 87.91 78.37 121.84 58.88 37.1 9.69 3 29.41"
        />
        <polygon
          className="cls-9"
          points="87.91 88.15 3 39.2 3 44.09 87.91 93.04 87.91 88.15"
        />
      </g>
    </svg>
  );
};
